import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard 
{

	constructor(private router: Router)
	{
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
	{
		// token expiration is now managed with refresh tokens in jwt http interceptor
		const token = AuthService.getAccessToken();
		if (token)
			return true;
		else
			this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
	}
}